import { createSelector } from 'reselect'
import { State } from 'index'

const pointCardSelector = (state: State) => state.pointCard

export const getPointCard = createSelector([pointCardSelector], (state) => state.pointCard)
